import { MultiLangString } from '../MultiLangString';

/** One bullet: bold lead + body (no HTML in DB). */
export interface NarrativeBulletMls {
  lead: MultiLangString;
  body: MultiLangString;
}

/**
 * CVC-12 deficit report copy. Headings / list layout live in the survey-report component;
 * DB holds plain text only (en/fr per field).
 */
export interface Cvc12ReportSectionNarrative {
  title: MultiLangString;
  /** Italic note below title (e.g. social-deficit, physical-social). */
  note?: MultiLangString;
  /** Short line between title and “The Explanation” (e.g. “The Social tank is…”). */
  subtitle?: MultiLangString;
  explanation: MultiLangString;
  actionPlanIntro: MultiLangString;
  bullets: NarrativeBulletMls[];
}

/**
 * Caregiver workload tier report copy. Section labels live in UI strings;
 * DB holds title + three blocks + bullets.
 */
export interface CwlTierReportNarrative {
  title: MultiLangString;
  whatThisMeans: MultiLangString;
  validatingYourExperience: MultiLangString;
  bullets: NarrativeBulletMls[];
}
